/**
 * Use Navigation Guard Hook
 *
 * Custom hook for monitoring unsaved changes state and managing navigation warnings.
 *
 * @since 1.0.0
 */

import { setUnsavedChanges as setGlobalUnsavedChanges, subscribeToUnsavedChanges } from '@redfox-thank-you/admin-utils';
import { useCallback, useEffect, useState } from 'react';

/**
 * Hook for monitoring navigation guard state
 *
 * @since 1.0.0
 *
 * @return Object with unsaved changes state and setter.
 */
export const useNavigationGuard = () => {
	const [hasUnsavedChanges, setLocalUnsavedChanges] = useState(false);

	useEffect(() => {
		const unsubscribe = subscribeToUnsavedChanges((hasChanges) => {
			setLocalUnsavedChanges(hasChanges);
		});

		return unsubscribe;
	}, []);

	const setHasUnsavedChanges = useCallback((hasChanges: boolean) => {
		setGlobalUnsavedChanges(hasChanges);
	}, []);

	return {
		hasUnsavedChanges,
		setHasUnsavedChanges,
	};
};
